import * as DOMPurify from 'dompurify';
if (window.trustedTypes && window.trustedTypes.createPolicy) {
    window.trustedTypes.createPolicy('default', {
        createHTML: string => DOMPurify.sanitize(string),
    });
}
